export enum WebsiteHeaderSelectors {
  FixedHeaderPlaceholder = '#SITE_HEADER-placeholder',
  FixedHeader = '#SITE_HEADER',
  FreemiumBannerCssSelector = '--wix-ads-top-height',
  ForumTopId = 'navigation-scroller',
}
